import { adminEvent, ContractTypes, getFilterPostedBy, getFilterShiftType, getMapUserFilterType, MiscType, pharmacyEvents, selectWorkshiftList } from '@pharmaplan/common';
import { filterByLongTerm, filterByPosted, filterByReplacementType, filterByShortTerm } from '@pharmaplan/common/helpers/utils';
import { useMemo } from 'react';
import { useAppSelector } from './useAppSelector';

const { shortTerm, longTerm } = ContractTypes;

const useMultiShiftFilter = () => {
  const pharmacistEvents = useAppSelector(selectWorkshiftList);
  const pharmacyEventsList = useAppSelector(pharmacyEvents);
  const adminEvents = useAppSelector(adminEvent);

  const filterReplacementType = useAppSelector(getMapUserFilterType);
  const filterShiftType = useAppSelector(getFilterShiftType);
  const filterPostedBy = useAppSelector(getFilterPostedBy);

  const filterPharmacyReplacementType = useMemo(
    () =>
      pharmacyEventsList.filter(
        filterByReplacementType(filterReplacementType ?? MiscType.All),
      ),
    [pharmacyEventsList, filterReplacementType],
  );

  const filteredAdminEvents = useMemo(() =>
    adminEvents.filter(filterByReplacementType(filterReplacementType ?? MiscType.All)), [adminEvents, filterReplacementType]);

  const shiftTypeFilter = useMemo(() => {
    switch (filterShiftType) {
      case longTerm.toString():
        return {
          pharmacistEvents: pharmacistEvents.filter(filterByLongTerm),
          pharmacyEventsList: filterPharmacyReplacementType.filter(filterByLongTerm),
          adminEvents: filteredAdminEvents.filter(filterByLongTerm).filter(filterByPosted(filterPostedBy)),
        };
      case shortTerm.toString():
        return {
          pharmacistEvents: pharmacistEvents.filter(filterByShortTerm),
          pharmacyEventsList: filterPharmacyReplacementType.filter(filterByShortTerm),
          adminEvents: filteredAdminEvents.filter(filterByShortTerm).filter(filterByPosted(filterPostedBy)),
        };
      default:
        return {
          pharmacistEvents,
          pharmacyEventsList: filterPharmacyReplacementType,
          adminEvents: filteredAdminEvents.filter(filterByPosted(filterPostedBy)),
        };
    }
  }, [filterPharmacyReplacementType, filterPostedBy, filterShiftType, filteredAdminEvents, pharmacistEvents]);

  return shiftTypeFilter;
};

export default useMultiShiftFilter;
